import React from 'react';
import DatePicker from 'react-datepicker';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, triggerSearch } from 'slices/glassSearchSlice';
import { Row, Col, InputGroup, Form, Button } from 'react-bootstrap';
import Totals from './totals-row/Totals';

const Filters = () => {
    const dates = useSelector(s => s.glassSearchFilter);
    const dispatch = useDispatch();

    return (
        <Row className='h-100 align-items-center'>
            <Col xs={6}>
                <Form.Group as={Row}>
                    <Form.Label className='vertical-align-middle' column xs={2}>Date</Form.Label>
                    <Col xs={8}>
                        <InputGroup>
                            <Col xs={5}>
                                <DatePicker
                                    calendarStartDay={1}
                                    id="date-from"
                                    className="form-control text-center"
                                    placeholderText="Select From"
                                    onChange={date => dispatch(setFilters({ ...dates, start: new Date(date).toISOString() }))}
                                    dateFormat={'dd/MM/yyyy'}
                                    selected={dates?.start ? new Date(dates?.start) : new Date()}
                                    isClearable
                                />
                            </Col>
                            <Col xs={1}>
                                <InputGroup.Text>To</InputGroup.Text>
                            </Col>
                            <Col xs={5}>
                                <DatePicker
                                    calendarStartDay={1}
                                    id="date-to"
                                    className="form-control text-center"
                                    placeholderText="Select To"
                                    onChange={date => dispatch(setFilters({ ...dates, end: new Date(date).toISOString() }))}
                                    dateFormat={'dd/MM/yyyy'}
                                    selected={dates?.end ? new Date(dates?.end) : new Date()}
                                    isClearable
                                />
                            </Col>
                        </InputGroup>
                    </Col>
                    <Col xs={2}><Button onClick={() => dispatch(triggerSearch())}>Search</Button></Col>
                </Form.Group>
            </Col>
            <Col xs={6} className='h-100'>
                <Totals />
            </Col>
        </Row>
    );
}

export default Filters;